module.exports = __webpack_public_path__ + "img/docx.e7ec0aab.png";